import React from 'react';
import { useParams } from 'react-router-dom';

const SubmitPortfolioPage: React.FC = () => {
    const { id } = useParams();
    return <>Submit page {id}</>;
}

export default SubmitPortfolioPage;